import type { ConsentDocKind } from '@/shared/data-types';
import { present } from '@/shared/overlay';
import { ConsentDocModal } from './consent-doc-modal';

/**
 * 지목 약관 원문 모달을 앱 루트 슬롯에 명령형 mount — 목록을 쥐지 않은 표면(`/help`·standalone 푸터)이 이 함수만 호출.
 * `openConsent`(문서 객체를 넘기는 판) 과 같은 오버레이·같은 본문이되 조회를 모달이 떠안는다.
 * `key` 로 같은 약관 중복 mount 방지(연타 스택 회피).
 */
export function openConsentDoc(kind: ConsentDocKind): void {
  present(
    ({ open, close }) => (
      <ConsentDocModal kind={kind} open={open} onOpenChange={(next) => !next && close()} />
    ),
    { key: `consent-doc:${kind}` },
  );
}
